import * as React from 'react';
import GridContainer from "../GenericComponents/Grids/GridContainer";
import {createBreadCrumbBasedOnPage} from "../../Utils/HelperFunctions";
import * as actionTypes from "../../store/action";
import {connect} from "react-redux";

interface TsrExpandedInfoProps {
    setBreadCrumbPath: (breadCrumbPath:BreadCrumb[]) => void;
}

interface TsrExpandedInfoState {
}

class TsrExpandedInfo extends React.Component<TsrExpandedInfoProps,TsrExpandedInfoState> {

    constructor(props: TsrExpandedInfoProps) {
        super(props);
    }

    componentDidMount(): void {
        this.props.setBreadCrumbPath(createBreadCrumbBasedOnPage(window.location.pathname.split('/').filter(x => x)));
    }

    render() {
        return (
            <GridContainer
                getGridDataUrl={'/api/auth/viewGridData/oasisTsrExpandedInfo'}
                addRecordUrl={'/api/auth/saveGridRecord/oasisTsrExpandedInfo'}
                editRecordUrl={'/api/auth/editGridRecord/oasisTsrExpandedInfo'}
                deleteRecordUrl={'/api/auth/removeGridRecord/oasisTsrExpandedInfo'}
                gridPaginated={true}
                formEditing={true}
                showUtilityColumns={true}
                exportLink={'viewGridData/oasisTsr/tsrExpandedInfo'}
                gridTitle={'View TSR Expanded Info'}
                gridId={'tsrExpandedInfoGrid'}
                typeForSuperClass={'oasisTsrExpandedInfo'}
            />
        );
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        setBreadCrumbPath: (breadCrumbPath:BreadCrumb[]) => dispatch(
            {type: actionTypes.SET_BREADCRUMB_PATH, payload: breadCrumbPath})
    }
};

export default connect(null, mapDispatchToProps)(TsrExpandedInfo);